// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inspection-card {
    display: flex;
    width: 100%;
    min-height: 60px;
    background-color: var(--color-grey000);
    border: 1px solid var(--color-grey100);
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-size: small;
}

.inspection-card-body {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    padding: 10px;
}

.inspection-card-data-area {
    width: 90%;
}

.inspection-card-action-area {
    align-self: center;
}

.inspection-card-line-service {
    display: flex;
    justify-content: center;
    flex: 1 1;
    padding-bottom: 0px;
}


.inspection-card-service {
    font-weight: 600;
    padding-bottom: 0;
}

.inspection-card-eta {
    font-weight: 200;
    font-style: italic;
    padding-left: 15px;
}

.inspection-card-line-tracking {
    display: flex;
    justify-content: center;
    flex: 1 1;
    padding-bottom: 5px;
    font-weight: 200;
    font-style: italic;
    padding-left: 10px;
    font-size: 12px;
}

.inspection-card-product-line {
    display: flex;
    justify-content: center;
    flex: 1 1;
    font-weight: 300;
    font-size: 11px;
    padding-bottom: 5px;
}

.inspection-card-certicicate-line {
    display: flex;
    justify-content: center;
    flex: 1 1;
    font-weight: 200;
    font-size: 11px;
}

.inspection-card-link-icon {
    position: absolute;
    top: 10;
    left: 10;
    color: var(--color-grey700);
}

.inspections-assigned-users {
    position: relative;
    padding-right: 10px;
    display: flex;
}

.inspections-assigned-users-icon {
    color: var(--color-grey700);
    font-weight: 700;
}

.inspections-assigned-users-count {
    color: var(--color-grey700);
    font-weight: 900;
    font-size: smaller;
}

.inspection-card-margin-right {
    margin-right: 5px; /* Adjust the value as needed */
}
`, "",{"version":3,"sources":["webpack://./src/components/inspection/cards/InspectionCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,sCAAsC;IACtC,sCAAsC;IACtC,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAO;IACP,mBAAmB;AACvB;;;AAGA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAO;IACP,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB,EAAE,+BAA+B;AACtD","sourcesContent":[".inspection-card {\n    display: flex;\n    width: 100%;\n    min-height: 60px;\n    background-color: var(--color-grey000);\n    border: 1px solid var(--color-grey100);\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    font-size: small;\n}\n\n.inspection-card-body {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    flex-grow: 1;\n    padding: 10px;\n}\n\n.inspection-card-data-area {\n    width: 90%;\n}\n\n.inspection-card-action-area {\n    align-self: center;\n}\n\n.inspection-card-line-service {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n    padding-bottom: 0px;\n}\n\n\n.inspection-card-service {\n    font-weight: 600;\n    padding-bottom: 0;\n}\n\n.inspection-card-eta {\n    font-weight: 200;\n    font-style: italic;\n    padding-left: 15px;\n}\n\n.inspection-card-line-tracking {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n    padding-bottom: 5px;\n    font-weight: 200;\n    font-style: italic;\n    padding-left: 10px;\n    font-size: 12px;\n}\n\n.inspection-card-product-line {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n    font-weight: 300;\n    font-size: 11px;\n    padding-bottom: 5px;\n}\n\n.inspection-card-certicicate-line {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n    font-weight: 200;\n    font-size: 11px;\n}\n\n.inspection-card-link-icon {\n    position: absolute;\n    top: 10;\n    left: 10;\n    color: var(--color-grey700);\n}\n\n.inspections-assigned-users {\n    position: relative;\n    padding-right: 10px;\n    display: flex;\n}\n\n.inspections-assigned-users-icon {\n    color: var(--color-grey700);\n    font-weight: 700;\n}\n\n.inspections-assigned-users-count {\n    color: var(--color-grey700);\n    font-weight: 900;\n    font-size: smaller;\n}\n\n.inspection-card-margin-right {\n    margin-right: 5px; /* Adjust the value as needed */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
